import { reportsApi } from "api/instances";
import { ReportTypes } from "modules/reports/models";
import moment from "moment";
import momentTimezone from "moment-timezone";

export class TopicReportHandler {
    private topicName: string;
    private topicId: string;

    constructor(topicName: string, topicId: string) {
        this.topicName = topicName;
        this.topicId = topicId;
    }

    public async requestReport(type: ReportTypes) {
        const tz = moment.tz(new Date(), momentTimezone.tz.guess());

        const request = {
            topicName: this.topicName,
            contentId: this.topicId,
            type: type.toString(),
            dateRequested: moment().format("YYYY-MM-DD hh:mm A"),
            clientTimeZone: tz.format('z'),
            clientTimeOffset: tz.format('Z')
        };
        await reportsApi.SendTopicReportRequest(request);
    }
}